module.exports = __webpack_public_path__ + "img/hondaaccord.0ee9f944.png";